import * as yup from "yup";

export const filtroProcessoCriarLoteSchema = yup.object().shape({
  empresa: yup.number().optional().nullable(),
  divisao: yup.number().optional().nullable(),
  servico: yup.number().optional().nullable(),
  centroCusto: yup.number().optional().nullable(),
  processos: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  placasChassis: yup
    .array()
    .of(yup.string().typeError("Placa ou chassi inválido"))
    .optional()
    .nullable(),
});